// extracted by mini-css-extract-plugin
export default {"flexRow":"ForgotPasswordEmailSent_flexRow__DV8uM","title":"ForgotPasswordEmailSent_title__kTNTw","resendButton":"ForgotPasswordEmailSent_resendButton__JtvJW"};